import React from 'react';
import { useLocation } from 'react-router-dom';
import PursuitLeaderForecast from './pursuitLeaderForecast';
import GcspForecast from './gcspForecast';
import { useRecoilState } from 'recoil';
import { Current_User } from '../../recoil/recoil';
import PursuitLeadePastForecast from './pastForecast/plPastForecast';
import GcspPastForecast from './pastForecast/gcspPastForecast';

function Forecast() {
  const location = useLocation();
  let data = location.state;
  const [currentUser, setCurrentUser] = useRecoilState(Current_User);
  if (data != null) {
    return (
      <>
        {' '}
        {currentUser != null && currentUser.role == 'PL' && (
          <PursuitLeadePastForecast data={data}></PursuitLeadePastForecast>
        )}
        {currentUser != null && currentUser.role == 'GCSP' && <GcspPastForecast></GcspPastForecast>}
      </>
    );
  } else {
    return (
      <>
        {' '}
        {currentUser != null && currentUser.role == 'PL' && (
          <PursuitLeaderForecast></PursuitLeaderForecast>
        )}
        {currentUser != null && currentUser.role == 'GCSP' && <GcspForecast></GcspForecast>}
      </>
    );
  }
}

export default Forecast;
